import BoxAlert from "./BoxAlert";

export default BoxAlert;
